import React from 'react';
import { dismissHero } from 'utils/boot';

/**
 * Around the pages loaded when needed (utils/lazyRoute): nothing while one loads, and when one
 * can't be loaded or breaks, a word about it instead of an empty page, until going to another.
 */
class RouteBoundary extends React.Component<{ pathname: string; children: React.ReactNode }, { failed: boolean; pathname: string }> {
  state = { failed: false, pathname: this.props.pathname };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props: { pathname: string }, state: { failed: boolean; pathname: string }) {
    return props.pathname === state.pathname ? null : { failed: false, pathname: props.pathname };
  }

  componentDidCatch() {
    // the start script's photo would cover the word about it
    dismissHero();
  }

  render() {
    if (this.state.failed) {
      return (
        <div style={{ padding: '4rem 1rem', textAlign: 'center' }}>
          <p>Nie udało się wczytać strony.</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Odśwież</button>
        </div>
      );
    }
    return <React.Suspense fallback={null}>{this.props.children}</React.Suspense>;
  }
}

/** Around an extra on a page: when it can't be loaded the page goes on without it. */
export class QuietBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed ? null : <React.Suspense fallback={null}>{this.props.children}</React.Suspense>;
  }
}

export default RouteBoundary;
